import { createStyles, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function (theme) {
    var _a, _b;
    return createStyles({
        tooltipCnt: {
            width: '100%',
            position: 'relative',
            filter: 'drop-shadow(0 0.125rem 1.25rem hsla(var(--valor-primario-azul-oscuro), 0.14))',
            zIndex: 5,
        },
        tooltip: (_a = {
                width: '202px',
                position: 'absolute',
                left: '-130px',
                top: '50px',
                padding: '.75rem',
                background: 'var(--blanco)',
                borderRadius: '6px',
                textAlign: 'center'
            },
            _a[theme.breakpoints.down('sm')] = {
                left: '-124px',
            },
            _a),
        flechaTooltip: (_b = {
                position: 'absolute',
                left: '-44px',
                top: '36px',
                width: '0',
                height: '0',
                borderStyle: 'solid',
                borderWidth: '1rem 1rem 0 1rem',
                borderColor: 'var(--blanco)transparent transparent transparent',
                transform: 'rotateZ(180deg)'
            },
            _b[theme.breakpoints.down('sm')] = {
                left: '-40px',
            },
            _b),
        tooltipItem: {
            display: 'flex',
            flexFlow: 'column',
            alignItems: 'center',
            fontSize: '12px',
        },
    });
});
export default useStyles;
